<div class="container-fluid">
  <div class="">
    <div class="row">
      <div class="col">
        <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="callDataList" [rows]="10"
          [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]" [lazy]="true">
          <p-column [style]="{'width': '10%'}" header="{{ 'CALLDATADATE' | translate }}">
            <ng-template pTemplate="options" let-row="rowData">
              <i>
                {{row['regDate'] | date:'short'}}
              </i>
            </ng-template>
          </p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'callReasonNameAr':'callReasonNameEn'}}"
            [style]="{'width': '12%'}" header="{{ 'CALLREASON' | translate }}"></p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'callResultNameAr':'callResultNameEn'}}"
            [style]="{'width': '12%'}" header="{{ 'CALLERRESULT' | translate }}"></p-column>
          <p-column field="notes" [style]="{'width': '25%'}" header="{{ 'NOTES' | translate }}"></p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'userNameAr':'userNameEn'}}" [style]="{'width': '12%'}"
            header="{{ 'USERNAME' | translate }}"></p-column>
        </p-dataTable>
      </div>
    </div>
  </div>
</div>